/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view: {
        'class': 'section section-register',
        $html: [{
            'class': 'bg-fixed abs-full',
            // $html: {
            //     'class': 'bg-mask'
            // }
        }, {
            'class': 'section-content abs-full',
            $html: {
                'class': 'container',
                $html: [{
                    'class': 'section-title',
                    $html: [{
                        'class': 'title-en',
                        $text: nb.bind('titleEn')
                    }, {
                        'class': 'title-cn',
                        $text: nb.bind('title')
                    }]
                }, {
                    $type: require('./List'),
                    $model: 'list'
                }, {
                    'class': 'question-tips',
                    $html: [{
                        tag:'i',
                        'class':'iconfont icon-yiwen'
                    },{
                        tag:'span',
                        $html:[{
                            tag:'span',
                            $text:nb.bind('tit1')
                        },{
                            tag:'a',
                            href:'help.html',
                            $text:nb.bind('tit2')
                        },{
                            tag:'span',
                            $text:nb.bind('tit3')
                        }]
                        // $html:'如有疑问，请点击<a href="help.html">采购流程</a>查看相关信息'
                    }]
                }]
            }
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/register/Register.js
// module id = 509
// module chunks = 6